import React, { useEffect, useMemo, useState } from "react";
import LoaderContainer from "../../mui/loader_container/LoaderContainer";
import ErrorBoundary from "../../mui/error_boundary/ErrorBoundary";
import TopUpBonus from "./bonus/TopUpBonus";
import TopUpCrypto from "./crypto/TopUpCrypto";
import TopUpReal from "./real/TopUpReal";
import TopUpSum from "./summ/TopUpSum";
import TopUpCards from "./cards/TopUpCards";
import { API_USER } from "../../../api/user";
import { ENUM_COMMON_EVENT } from "../../../hooks/common/useListener";
import { dispatchCusEvent } from "../../../utils/utils";
import { DEBUG, ENUM_BALANCE_TYPE, TEST_MODE } from "../../../store/enums";
import { useAppSelector } from "../../../store/index.ts";
import { useDispatch } from "react-redux";
import { errorToast } from "../../mui/Toaster";
import { useTranslation } from "react-i18next";
import { testDeposit } from "../../../store/testConst";
import { setCurrency } from "../../../store/userSlice";
import { setLockBalanceClose } from "../../../store/siteSlice";
import Cryptogate from "./cryptogate/Cryptogate.jsx";
import CaptchaContainer from "./step3/CaptchaContainer.jsx";

export default function StepContainer({
  closeModal,
  isOpen,
  setLockedInfo,
  lockedInfo,
  setOpenPaymentPhone,
  setOpenPaymentCard,
  defaultDeposit
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const balance = useAppSelector((state) => state.user.balance);
  const currency = useAppSelector((state) => state.user.currency);
  const lockBonusClose = useAppSelector((state) => state.site.lock.balanceClose);

  const [loader, setLoader] = useState(true);
  const [data, setData] = useState({});
  const [step, setStep] = useState(1);
  const [min, setMin] = useState(undefined);
  const [max, setMax] = useState(undefined);
  const [taxPercent, setTaxPercent] = useState(null);
  const [chooseCryptogate, setChooseCryptogate] = useState(false);
  const [methodDataPay, setMethodDataPay] = useState({ method: undefined, data: {} });

  const type = useMemo(() => balance?.[currency]?.info?.type, [currency, balance]);
  const isCrypto = useMemo(() => type === ENUM_BALANCE_TYPE.crypto, [type]);
  const percent = useMemo(() => {
    const amount = data.amount;

    for (let percent in taxPercent) {
      const curCondition = taxPercent[percent];
      if (curCondition.from && curCondition.to) {
        if (curCondition.from <= amount && curCondition.to >= amount) return percent;
      } else if (curCondition.from) {
        if (curCondition.from <= amount) return percent;
      } else if (curCondition.to) {
        if (curCondition.to >= amount) return percent;
      }
    }
  }, [data, taxPercent]);

  const checkOpen = (data) => {
    if (!isOpen) return;
    const sessionError = ENUM_COMMON_EVENT.sessionError;

    if (data.errorCode === 1) dispatchCusEvent(sessionError);
  };

  useEffect(() => {
    let countLoader = 0;

    const checkLoader = () => {
      countLoader++;
      if (countLoader == 2) setLoader(false);
    };

    setStep(1);

    if (!isOpen) return;
    if (!currency) return;
    if (TEST_MODE) {
      const data = testDeposit;
      dispatch(setCurrency(data.currency));
      setMin(data.minAmount);
      setMax(data.maxAmount);
      setLoader(false);
      return;
    }

    API_USER.balance
      .getDepositLockInfo()
      .then((e) => {
        if (DEBUG) console.log("limit deposit res", e);
        const data = e.data;
        if (!data) errorToast(t("An error has occurred"));

        setLockedInfo(data);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => {
        checkLoader();
      });

    API_USER.balance
      .limit()
      .then((e) => {
        if (DEBUG) console.log("limit deposit res", e);
        const data = e.data;
        if (!data) errorToast(t("An error has occurred"));
        checkOpen(data);
        setMin(data.minAmount);
        setMax(data.maxAmount);
        setTaxPercent(data.taxPercent);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => checkLoader());
  }, [isOpen, isCrypto, currency]);

  useEffect(() => {
    if (isCrypto) dispatch(setLockBalanceClose(false));
  }, [isCrypto]);

  if (TEST_MODE) {
    return (
      // <TopUpReal
      //   currency={currency}
      //   closeModal={!lockBonusClose && closeModal}
      //   maxInvoices={lockedInfo?.maxInvoices}
      //   taxPercent={taxPercent}
      //   max={max}
      //   min={min}
      //   setStep={setStep}
      //   setData={setData}
      // />

      // STEP 2

      // <>
      //   <TopUpSum currency={"RUB"} value={1550.57} percent={7.5} setStep={setStep} />
      //   <TopUpCards
      //     amount={data.amount}
      //     currency={data.currency}
      //     closeModal={!lockBonusClose && closeModal}
      //     setLockedInfo={setLockedInfo}
      //     setOpenPaymentPhone={setOpenPaymentPhone}
      //     setOpenPaymentCard={setOpenPaymentCard}
      //   />
      // </>

      // STEP 3
      <CaptchaContainer />
    );
  }

  if (step === 1) {
    return (
      <LoaderContainer loader={loader} center>
        <ErrorBoundary>
          <TopUpBonus />
        </ErrorBoundary>
        {isCrypto ? (
          <TopUpCrypto currency={currency} min={min} setStep={setStep} closeModal={closeModal} />
        ) : (
          <TopUpReal
            defaultDeposit={defaultDeposit}
            currency={currency}
            closeModal={!lockBonusClose && closeModal}
            maxInvoices={lockedInfo?.maxInvoices}
            max={max}
            min={min}
            taxPercent={taxPercent}
            setStep={setStep}
            setData={setData}
          />
        )}
      </LoaderContainer>
    );
  }

  if (step === 2) {
    return (
      <>
        <TopUpSum
          currency={data.currency}
          value={data.amount}
          setStep={setStep}
          percent={percent}
        />
        <TopUpCards
          amount={data.amount}
          currency={data.currency}
          setOpenPaymentPhone={setOpenPaymentPhone}
          setOpenPaymentCard={setOpenPaymentCard}
          setChooseCryptogate={setChooseCryptogate}
          setMethodDataPay={setMethodDataPay}
          setStep={setStep}
        />
      </>
    );
  }

  if (step === 3) {
    if (chooseCryptogate) return <Cryptogate info={chooseCryptogate} />;

    return (
      <CaptchaContainer
        closeModal={closeModal}
        methodDataPay={methodDataPay}
        setLockedInfo={setLockedInfo}
        setOpenPaymentPhone={setOpenPaymentPhone}
        setOpenPaymentCard={setOpenPaymentCard}
        setChooseCryptogate={setChooseCryptogate}
      />
    );
  }
}
